import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import ConversationPopupView from './ConversationPopupView';
import s from './ConversationPopup.css';
import {
  getConversation,
  sendMessageToConversation,
  sendMessageToUser,
  resetPaging,
  resetConversation,
  hideConversation
} from '../../actions/ConversationActions';

class ConversationPopup extends React.Component {
  render() {
    const {conversationPaging, hideConversation, authentication} = this.props; // eslint-disable-line no-shadow
    const producent = authentication.get('producent');
    if (conversationPaging.get('showConversation')) {
      return (
        <ConversationPopupView
          {...this.props}
          conversationPaging={conversationPaging}
          onClose={hideConversation}
          producent={producent}
        />
      );
    }
    return null;
  }
}

const mapState = state => ({
  conversation: state.conversation,
  conversationPaging: state.conversationPaging,
  authentication: state.authentication,
});

const mapDispatch = dispatch => {
  return {
    getConversation: conversationId => 
      dispatch(getConversation(conversationId)),
    sendMessageToConversation: (conversationId, data) => 
      dispatch(sendMessageToConversation(conversationId, data)),
    sendMessageToUser: (userId, data) => 
      dispatch(sendMessageToUser(userId, data)),
    resetPaging: () => dispatch(resetPaging()),
    resetConversation: () => dispatch(resetConversation()),
    hideConversation: () => dispatch(hideConversation()),
  };
};

ConversationPopup.propTypes = {
  conversation: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  conversationPaging: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  getConversation: PropTypes.func.isRequired,
  sendMessageToConversation: PropTypes.func.isRequired,
  sendMessageToUser: PropTypes.func.isRequired,
  resetPaging: PropTypes.func.isRequired,
  resetConversation: PropTypes.func.isRequired,
  hideConversation: PropTypes.func.isRequired,
  authentication: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

export default compose(withStyles(s), connect(mapState, mapDispatch))(
  ConversationPopup
);


// WEBPACK FOOTER //
// ./src/components/ConversationPopup/ConversationPopup.js